import logoEE2 from "@assets/events-awards/ee/logo-ee-2.png";
import { AWARD_LOGOS } from "@events-awards/utils/constants";
import { AwardType } from "@events-awards/utils/types";
import { useWindowSize } from "@hooks/useWindowSize";

type EventsAwardsLogoProps = {
  /** The award type is used to display logo based on the type of awards i.e (SIA, SBA, etc...). */
  awardType: string;
};

/**
 * Events Awards Logo component
 */
const EventsAwardsLogo = ({
  awardType,
}: EventsAwardsLogoProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();
  const config = AWARD_LOGOS[awardType];

  if (!config) return <></>;

  return (
    <>
      <img
        src={config.logo}
        alt={`${awardType}-logo`}
        width={isScreenLG ? config.widthDesktop : config.widthMobile}
        height={isScreenLG ? config.heightDesktop : 60}
      />

      {awardType === AwardType.EE ? (
        <img
          src={logoEE2}
          alt={`${awardType}-logo`}
          width={181}
          height={70}
          className="ml-2"
        />
      ) : null}
    </>
  );
};

export default EventsAwardsLogo;
